// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"960c0ca4","359":"d1429145"}[chunkId] + ".chunk.js";
};